var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888889 0C0.653141 0 0.427048 0.0936505 0.260349 0.260349C0.0936505 0.427048 0 0.653141 0 0.888889V15.1111C0 15.3469 0.0936505 15.573 0.260349 15.7397C0.427048 15.9064 0.653141 16 0.888889 16H9.77778C10.0135 16 10.2396 15.9064 10.4063 15.7397C10.573 15.573 10.6667 15.3469 10.6667 15.1111V10.9307L11.5556 15.1111C11.6046 15.3417 11.7432 15.5433 11.9409 15.6716C12.1386 15.8 12.3792 15.8446 12.6098 15.7956L16.0871 15.056C16.3177 15.0069 16.5193 14.8683 16.6476 14.6706C16.776 14.4729 16.8206 14.2323 16.7716 14.0018L14.1849 1.82933C14.1358 1.59879 13.9972 1.39717 13.7995 1.26881C13.6018 1.14046 13.3612 1.09588 13.1307 1.14489L10.6596 1.66933C10.6331 1.45407 10.5288 1.2559 10.3664 1.11216C10.204 0.968411 9.99466 0.889004 9.77778 0.888889H6.22222C6.22222 0.653141 6.12857 0.427048 5.96187 0.260349C5.79517 0.0936505 5.56908 0 5.33333 0H0.888889ZM6.22222 2.66667H8.88889V9.77778H6.22222V2.66667ZM6.22222 14.2222V11.5556H8.88889V14.2222H6.22222ZM4.44444 1.77778V10.6667H1.77778V1.77778H4.44444ZM4.44444 12.4444V14.2222H1.77778V12.4444H4.44444ZM12.7396 12.1333L14.4782 11.7636L14.848 13.5022L13.1093 13.872L12.7396 12.1333ZM12.3698 10.3938L10.8916 3.43822L12.6302 3.06844L14.1093 10.0249L12.3698 10.3938Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b8e1aadac3754b64ee6800d01e51e7da.svg";
export { ForwardRef as ReactComponent };